// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_ACFdx grid","Head":"Hero__Head_3tzyv","Title":"Hero__Title_2X0Pe","Description":"Hero__Description_1h2B7"};